import { FunctionComponent } from 'react';

// Libs
import classnames from 'classnames';
import { useRouter } from 'next/router';
import { stringify } from 'query-string';

// Components
import { getQueryPopular } from '../PopularCard';

// Styles
import styles from './ListFilter.module.scss';
import Image from '@Components/Utils/Image';

interface ListFilterProps {
    className?: string;
    listsTags?: any;
}

const ListFilter: FunctionComponent<ListFilterProps> = ({ className, listsTags }) => {
    const { push, query } = useRouter();
    // const { listsTags } = useNewsFeed();

    const newQuery = { ...query };
    delete newQuery['pho_bien'];
    const popularQuery = getQueryPopular(query?.['pho_bien']);

    const deleteFilter = (idFilter: string) => {
        // const newPopular = popularQuery.includes(id) ? LdDifferent(popularQuery, [id]) : LdConcat(popularQuery, id);
        if (popularQuery.includes(idFilter)) {
            const newPopular = popularQuery.filter((slug) => slug !== idFilter);
            const newQueryParams = stringify({ ...newQuery, pho_bien: newPopular }, { skipEmptyString: true });
            newQueryParams?.length > 0 ? push(`/hoi-dap?${newQueryParams}`) : push('/hoi-dap');
        }
    };

    const ListFilter = listsTags.filter(({ slug }) => popularQuery.includes(slug));

    const renderListFilter = () => {
        return ListFilter?.map(({ title, slug }) => (
            <div key={slug} className={styles.filter_item}>
                {title}
                <Image
                    width={16}
                    height={16}
                    className={styles.close}
                    src="/assets/icon_close.png"
                    onClick={() => deleteFilter(slug)}
                />
            </div>
        ));
    };

    const wrapperClassName = classnames([styles.wrapper, { [styles.filter_null]: ListFilter.length === 0 }, className]);

    return <div className={wrapperClassName}>{renderListFilter()}</div>;
};

ListFilter.defaultProps = {
    className: '',
};

export default ListFilter;
